import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const Process = () => {
	const theme = useTheme();

	return (
		<Box>
			<Box marginBottom={4}>
				<Typography
					sx={{
						textTransform: "uppercase",
						fontWeight: "medium",
					}}
					gutterBottom
					color="secondary"
					align="center">
					<svg
						width={40}
						height={40}
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor">
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
						/>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
						/>
					</svg>
				</Typography>
				<Box
					component={Typography}
					fontWeight={700}
					variant="h3"
					gutterBottom
					align="center">
					Our process is simple & effective
				</Box>
				<Typography
					variant="h6"
					component="p"
					color="textSecondary"
					align="center">
					We help you create, manage and sell territories to potential
					franchisees.
				</Typography>
			</Box>
			<Grid
				container
				spacing={4}>
				{[
					{
						title: "",
						subtitle:
							"Define a profile of an ideal territory by reviewing the criteria you have set or have used in the past.",
					},
					{
						title: "",
						subtitle:
							"Review your development plans and prepare a territory mapping solution to support the plan.",
					},
					{
						title: "",
						subtitle:
							"Identify and gather the latest demographic data for reporting, mapping & territory creation.",
					},
					{
						title: "",
						subtitle:
							"Identify and gather POI such as competitor locations, anchor tenants and your own locations.",
					},
				].map((item, i) => (
					<Grid
						item
						xs={12}
						sm={6}
						md={3}
						key={i}
						data-aos="fade-up">
						<Box
							display="flex"
							flexDirection="column">
							<Box
								display="flex"
								alignItems="center"
								marginBottom={1}>
								<Box
									borderRadius="100%"
									bgcolor={theme.palette.primary.main}
									marginRight={2}
									width={40}
									height={40}
									display="flex"
									justifyContent="center"
									alignItems="center">
									<Box
										component={Typography}
										variant="h6"
										fontWeight={700}
										color={theme.palette.common.white}>
										{i + 1}
									</Box>
								</Box>
								<Typography
									variant="h6"
									gutterBottom
									fontWeight={500}>
									{item.title}
								</Typography>
							</Box>
							<Typography
								variant="h6"
								color="text.secondary">
								{item.subtitle}
							</Typography>
						</Box>
					</Grid>
				))}
			</Grid>
		</Box>
	);
};

export default Process;
